// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_2-fdIPlmDHK6ASBbZ2Vta7"};